import * as jsxRuntime from "D:\\notify_sfz\\react\\suyodaHome\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment